import { render, staticRenderFns } from "./BtnCotacao.vue?vue&type=template&id=4399a7c0&"
import script from "./BtnCotacao.vue?vue&type=script&lang=js&"
export * from "./BtnCotacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports